import { WppModal, WppTypography } from '@wppopen/components-library-react'
import clsx from 'clsx'
import styles from '../Modal.module.scss'
import { ImportClientForm } from 'components/Forms'
import type { ClientsCreatePayload, ClientsDetailData } from '@contracts'

interface ImportEditClientModalProps {
  isModalOpen: boolean
  isApiLoading: boolean
  onCancel: () => void
  onSubmit: (data: ClientsCreatePayload) => Promise<void>
  clientData?: ClientsDetailData
}

export default function ImportEditClientModal({
  isModalOpen,
  isApiLoading,
  onCancel,
  onSubmit,
  clientData,
}: ImportEditClientModalProps) {
  return (
    <WppModal open={isModalOpen} className={clsx(styles.modal_reset_overflow, styles.modal)}>
      <WppTypography tag="h3" type="l-strong" slot="header">
        {!!clientData ? 'Edit' : 'Import'} Client
      </WppTypography>

      <div slot="body">
        <ImportClientForm
          clientData={clientData}
          onSubmitForm={onSubmit}
          onCancelForm={onCancel}
          isAPILoading={isApiLoading}
        />
      </div>
    </WppModal>
  )
}
